import { render, staticRenderFns } from "./OrderDuplicatedInfo.vue?vue&type=template&id=40be3def&scoped=true&"
import script from "./OrderDuplicatedInfo.vue?vue&type=script&lang=js&"
export * from "./OrderDuplicatedInfo.vue?vue&type=script&lang=js&"
import style0 from "./OrderDuplicatedInfo.vue?vue&type=style&index=0&id=40be3def&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40be3def",
  null
  
)

export default component.exports